export default __webpack_public_path__ + "static/media/title_zh_tw_sp.fc61d5dc.png";